"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M2.014 4L12 13.986 21.986 4H2.014z" }),
    React.createElement("path", { d: "M2 6.814l9.293 9.293h1.414L22 6.814V18a2 2 0 01-2 2H4a2 2 0 01-2-2V6.814z" })), "Email");
//# sourceMappingURL=Email.js.map